<div class="content">
    <div class="widget">
        <h2 class="pb-s">Umsatzkennzahlen</h2>
        <p>Hier können Sie Ihre aktuellen Umsatzkennzahlen einsehen.</p>
        <div *ngIf="revenue" class="mt-l">
            <h3 class="pb-0">{{ revenue.month | translate }} {{ today |date: 'yyyy' }}</h3>
            <p class="disclaimer">Stand: {{ revenue.updatedAt | date: 'dd.MM.yyyy HH:mm' }}</p>
            <div class="row mt-s">
                <div class="col-sm-3">
                    <div class="mb-s"><img src="/assets/img/icons/tiles/euro.svg" alt="Umsatz total"></div>
                    <h4>Umsatz total</h4>
                    <div class="revenue">
                        {{ (revenue.totalRevenue ? revenue.totalRevenue : 0) | currency:'EUR':'symbol':'1.2-2' }}
                    </div>
                </div>
                <div class="col-sm-3">
                    <div class="mb-s"><img src="/assets/img/icons/tiles/packungen.svg" alt="Anzahl RX Packungen"></div>
                    <h4>Anzahl RX Packungen
                        <mat-icon class="info-icon" matTooltip="inkl. Hochpreis">info</mat-icon>
                    </h4>
                    <div class="revenue">
                        {{ (revenue.rxPacketCount ? revenue.rxPacketCount : 0) | number }}
                    </div>
                </div>
                <div class="col-sm-2">
                    <div class="mb-s"><img src="/assets/img/icons/tiles/ist_spanne.svg" alt="Ist Spanne"
                                           class="little-bit-smaller-icon"
                                           [ngClass]="!digitalPaket && !userService.isInternalUser() ? 'disabled' : ''">
                    </div>
                    <h4 [ngClass]="!digitalPaket && !userService.isInternalUser() ? 'disabled' : ''">Ist Spanne
                    </h4>
                    <div class="revenue" *ngIf="digitalPaket">
                        {{ (revenue.rxSpanPercent ? revenue.rxSpanPercent : 0) | number }} %
                    </div>
                    <div class="revenue" *ngIf="!digitalPaket && userService.isInternalUser()">
                        {{ userService.canInternalUserChangeIdfSelection(InternalUserAuthority.SALES_ADMINISTRATION) ? ((revenue.rxSpanPercent ? revenue.rxSpanPercent : 0) | number) : "0" }}
                        %
                    </div>
                    <p *ngIf="!digitalPaket && !userService.isInternalUser()" class="no-paket mt-s">Die aktuellen Werte
                        zu Ist Spanne und RX Packungswert werden nur bei
                        Nutzung des PHOENIX Digitalpakets angezeigt. --> <a
                                href="https://phoenix-apothekenportal.de/phoenix-digitalpaket" target="_self">Jetzt
                            freischalten</a>
                    </p>
                </div>
                <div class="col-sm-1">
                    <div class="mb-s"><img src="/assets/img/icons/tiles/ist_spanne.svg" style="visibility: hidden"
                                           alt="Ist Spanne"
                                           [ngClass]="!digitalPaket ? 'disabled' : ''"></div>
                    <h4 [ngClass]="!digitalPaket ? 'disabled' : ''" style="visibility: hidden">Entspricht
                    </h4>
                    <div class="revenue" *ngIf="digitalPaket">
                        ≙
                    </div>
                </div>
                <div class="col-sm-3">
                    <div class="mb-s"><img src="/assets/img/icons/tiles/rx_packungswert.svg" alt="RX Packungswert"
                                           [ngClass]="!digitalPaket && !userService.isInternalUser() ? 'disabled' : ''">
                    </div>
                    <h4 [ngClass]="!digitalPaket && !userService.isInternalUser() ? 'disabled' : ''">RX Packungswert
                        <mat-icon class="info-icon"
                                  matTooltip="Der dargestellte Wert entspricht dem ~ RX Packungswert zur ausgewiesenen Ist Spanne.">
                            info
                        </mat-icon>
                    </h4>
                    <div class="revenue" *ngIf="digitalPaket">
                        Ø {{ (revenue.rxSpanPercent ? ((0.73 / 1.0315) / ((revenue.rxSpanPercent / 100) - 1 + (1 / 1.0315))) : 0) | number:'1.1-1' }}0 €
                    </div>
                    <div class="revenue" *ngIf="!digitalPaket && userService.isInternalUser()">
                        {{ userService.canInternalUserChangeIdfSelection(InternalUserAuthority.SALES_ADMINISTRATION) ? ((revenue.rxSpanPercent ? ((0.73 / 1.0315) / ((revenue.rxSpanPercent / 100) - 1 + (1 / 1.0315))) : 0) | number:'1.1-1') : "0, 0" }}0 €
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="widget">
        <h2 class="pb-s">Monatlicher Umsatzverlauf</h2>

        <mat-tab-group #tabGroup mat-stretch-tabs="false" mat-align-tabs="start"
                       (selectedTabChange)="loadRevenues($event)" [ngClass]="{'hide-header' : !hasPkpRevenue}">
            <mat-tab label="Gesamt">
                <div class="chart" echarts [options]="options" (chartInit)="onChartInit($event)"></div>
                <div class="border-top" *ngIf="revenue">
                    <div class="container p-0">
                        <div class="row">
                            <div class="col-md-6 col-xs-12">
                            </div>
                            <div class="col-md-6 col-xs-12">
                                <div class="text-sm-left text-md-right">
                                    <h4 class="mb-2">Download</h4>
                                    <button class="btn-primary btn-round" (click)="savePdf('Gesamt')">
                                        <mat-icon class="text-white">arrow_downward</mat-icon>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="revenue" *ngIf="loading">
                        <mat-icon class="icon-spin">progress_activity</mat-icon>
                    </div>
                </div>
            </mat-tab>
            <mat-tab label="PKP">
                <div class="chart" echarts [options]="options" (chartInit)="onChartInitPkp($event)"></div>
                <div class="border-top">
                    <div class="container p-0">
                        <div class="row">
                            <div class="col-md-6 col-xs-12">
                            </div>
                            <div class="col-md-6 col-xs-12">
                                <div class="text-sm-left text-md-right">
                                    <h4 class="mb-2">Download</h4>
                                    <button class="btn-primary btn-round" (click)="savePdf('PKP')">
                                        <mat-icon class="text-white">arrow_downward</mat-icon>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-tab>
        </mat-tab-group>
    </div>
    @if (isLive()) {
        <div class="widget">
            <div id="accordion1" class="accordion-style-1">
                <div class="card">
                    <div class="card-header">
                        <button aria-controls="collapseTwo"
                                aria-expanded="false"
                                data-target="#collapseTwo"
                                data-toggle="collapse"
                                type="button"
                                class="btn btn-link btn-collapsible collapsed">
                            <h4>Informationen zum Energiekostenzuschlag (EKZ)</h4>
                        </button>
                    </div>
                    <div data-parent="#accordion1"
                         id="collapseTwo"
                         class="collapse">
                        <ul>
                            <li>
                                <a class="linki" target="_blank"
                                   href="https://www.adac.de/verkehr/tanken-kraftstoff-antrieb/deutschland/kraftstoffpreisentwicklung/#spritpreise-die-letzten-24-monate">Dieselpreise laut ADAC</a>
                            </li>
                            <li>
                                <a class="linki" target="_blank" disabled
                                   href="https://cspappsacc.blob.core.windows.net/cms/files/2026/Übersicht EKZ gemäß Dieselpreis.pdf">Übersicht EKZ gemaß Dieselpreis</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    }
</div>